/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, G, Circle, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Broadcast(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <G>
        <Circle cx={128} cy={128} r={40} />
        <Path d="M82.74512,82.74512A8.00018,8.00018,0,1,0,71.43066,71.43164a79.94026,79.94026,0,0,0,0,113.13672,8.00018,8.00018,0,1,0,11.31446-11.31348,63.93958,63.93958,0,0,1,0-90.50976Z" />
        <Path d="M208,128a79.7769,79.7769,0,0,0-23.43066-56.56836,8.00018,8.00018,0,1,0-11.31446,11.31348,63.93958,63.93958,0,0,1,0,90.50976,8.00018,8.00018,0,0,0,11.31446,11.31348A79.7769,79.7769,0,0,0,208,128Z" />
        <Path d="M32.16992,168.479a103.90428,103.90428,0,0,1,22.291-114.01806A8.00018,8.00018,0,0,0,43.14648,43.14746a119.906,119.906,0,0,0,0,169.70508,8.00018,8.00018,0,1,0,11.31446-11.31348A103.65105,103.65105,0,0,1,32.16992,168.479Z" />
        <Path d="M238.56641,81.28809a119.58135,119.58135,0,0,0-25.71289-38.14063,8.00018,8.00018,0,1,0-11.31446,11.31348,103.90471,103.90471,0,0,1,0,147.07812,8.00018,8.00018,0,0,0,11.31446,11.31348A120.12116,120.12116,0,0,0,238.56641,81.28809Z" />
      </G>
    </Svg>
  );
}

export default Broadcast;
